module.exports = __webpack_public_path__ + "media/images/front/icon_down_d-fc873121f30cdc917a1491625924e074.png";